<template>
  <vh-aside v-if="!hideSideBar" class="ai-sidebar" :class="[{ collapse: isCollapse }]">
    <!-- saas控制台用非嵌入页方式，有logo -->
    <LogoBar></LogoBar>
    <!-- 菜单区域 -->
    <vh-menu
      ref="menus"
      class="ai-sidebar-menu"
      :collapse="isCollapse"
      :default-active="activeIdx"
      :collapse-transition="false"
      :unique-opened="true"
      @select="selectMenu"
    >
      <template v-for="item in menus">
        <vh-submenu
          v-if="item.children && item.children.length"
          :key="item.index"
          :index="item.index"
          :class="[{ [item.index]: true, active: activeIdxPath.indexOf(item.index) > -1 }]"
        >
          <template slot="title">
            <i class="vh-iconimg menu-icon"></i>
            <span slot="title">{{ item.title }}</span>
          </template>
          <vh-menu-item
            v-for="subItem in item.children"
            :key="subItem.index"
            :index="subItem.index"
            @click="goTo(subItem.feature)"
          >
            {{ subItem.title }}
          </vh-menu-item>
        </vh-submenu>
      </template>
    </vh-menu>
  </vh-aside>
</template>

<script>
  import LogoBar from './LogoBar.vue';
  import { getCurrentMenus } from '@/biz/menu';

  export default {
    name: 'AiSideBar',
    components: {
      LogoBar
    },
    data() {
      return {
        activeIdx: '',
        activeIdxPath: [],
        menus: []
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      isCollapse() {
        return this.$store.state.sidebar.isCollapse;
      },
      revoId() {
        return this.$isEmbed
          ? this.$store.state.video.recordInfo?.vod_id
          : this.$store.state.video.recordInfo?.id;
      },
      embedCfgFeature() {
        return this.$store.state.embedCfg.feature;
      },
      hideSideBar() {
        return !!this.embedCfgFeature?.ai_hide_menu;
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          this.activeIdx = this.$route.name;
          if (this.activeIdx === 'AiVideoParsing') {
            this.activeIdxPath = ['video-base', this.activeIdx];
          } else {
            this.activeIdxPath = ['video-operate', this.activeIdx];
          }
        },
        immediate: true
      },
      embedCfgFeature() {
        this.menus = getCurrentMenus();
      }
    },
    created() {
      this.menus = getCurrentMenus();
    },
    methods: {
      // 点菜单跳转
      goTo(feature) {
        const action = feature.replace('ai_video_', '');
        const prefix = this.$isWxwork ? '/embed/wxwork' : this.$isEmbed ? '/embed' : '';
        this.$router.push(`${prefix}/video/${action}/${this.revoId}`);
      },
      // 菜单被选中时触发
      selectMenu(index, indexPath) {
        this.activeIdx = index;
        this.activeIdxPath = indexPath;
      }
    }
  };
</script>
<style lang="less">
  @ai-base-active-icon-image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOISURBVHgB5VhdUtswEP6cBEqfyBHUGQgZXpqeAN+A3CC+AeEESU+AOQHhBMAJEk7Q8BZ4sW9A3tppEqvaWMKKKsc/MUNn+s3siEgr6fNqd7UC+E/gChkLeRXC5d8d/CPoISZlkx4+GExIgJiML6QpZSj7XuXvD4OHmMi9ZWwsxzzsgBp2A5Pt1DL2aOiUQlGCzPgdyvbMotsxdNLWqAQM9iMj/1KRO9D6rpD4INP0Pdl/gwqJkiUCbcOuMd5HehT3DV1XWytABamoh83cxlL0ukgsrHTdFF2m6do+ODc62oY+qscQCcnClmRIjmKI98MQdl/NhDqCO7w/1F7jvBM8JE7M8P7QM4GXZ0JQRHlxdOQuWi3+6+Skn6pzfHy1bLUCzljatacyQWAOmInaQ2y1UMgIeVCvr/NfnfNBKoFarSN2Z8uDg7Rg8OWeDEb0mwRVyH9HDvxstxk4d+XP5nJ/v4/yuJbtQO80CZ7LdoIcqEfRkFruOJfG/DIYyZas/HYSOkFXtnTxh8gAHaeYfOYI3f3nZ19YckKLL9ptF+Uwl3s3oeVFnaDqfEQOLA4OuuRXcJzJuqNej91itRqgPB4NLhsEmWxD5EAtitZExPHecuGLjXjeVBB2t0RrFkKDywZBtegcGaBj5GqRKBovoygggfzyHYJF7X0IC8Hc4FHkUUv+Z4pUudjBihtooCAotThR1CMyjZeXL+a4SNpD0QwWnz55qKDI0C1I7wqKosm2CSq1RJxbc+WyVhtRKz6iTMqZSnlII/gNGUGiUsveYmF7KOHzbBauU44Ilt+np0XLqKnk8LZ24SMWwXErInfeCMPUYOJ7e5e11eqiEUVrHYfza0H6qTGbTVAQjqWPnJuuPPp62mCCnDdLCbhSaE+y3ihrAkNSzehyg2of4LTW2LJPZomnyNHXUC7ztb4rVIcRkkral3vpjymrMbwUBYakoKzCigyJxZjWT2v/gPEatBULVPboARAiuSO72B0qsh+wmTHmSEqur7AQzIPMazAH1CkcbhmzQi+7dUX9+cmwO5raeh2jP/O5oTsqOS9Fr/K/Kt/GPjYzhK/tE2ybyGBPM1WSs5HU/yPBdCUnZbIrRVW5E2O8K/vy+mRTrndv9DMkgWfbpxQ8JDnsTv52sem3qmwnv9bdpGydWAgM9lsgS/46vjxwUB4MseXO5d8kelWu7vEnxDdHqRT1B8NEXfv1M4hxAAAAAElFTkSuQmCC';

  @ai-operate-active-icon-image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQXSURBVHgBxVjbcdtGFD2gRXryFXWQzQdBjn+CdLCuIOxAcAVhKiBSgd0B6QqkDqgOpC+Pxj9kKiD/ktEDyF5yF7hY7YuyRz4zdwgu7mLP3ucCwA9AI8R5it4Ar4jHPJ895PnucTTaqd9FTD/DK+Hf6VQM63rdAKIdHAzeD+/urn1zXs1yb+q6ImJZll2rv3/TWFbXy5CLU8gJJVJJoSQpVmzcT6elctGFuty/ybIPw69fK3V9S2Qf376NutdGqWStZKeksWSn75XgLvKA3KlibaNirFFStYTfvSv0WPMwnUokQOiFOZmNkhstLrKX8FiUFjXE6PfZfUVWE9z9N5nMESG2YYTmnkVJr9SkDEHJFSiOHsbjj61l8vy2URZ0LXqf5yujRxvw6Rlit0iLLYqVnU2OW4sswl3pA8Ukm9PYZaZEZ7EYMaE3YKy21GNHix0JNY+TydpnBRcoNrkVaZMmWy/0L6X4PvCMGY6x95uSrZL3Sj7oazwMh0Jvbl/X9efs7m6LRPykdJ8Gg8qs3zRNYe4ZK4SstmB6K5+uirV1G0OTyTLVeveTyZ+t1VnsCXQuTSFWIQKdhe1C9+Nx6dM9lBQVAu2GxuNPvDBLveg6gViJRFAMcSu6SsVBh23CVe8E/JZ7ETEO5a65yVzbxW0NtKzlIrezxmeMWLBAxkCLHwgqS5oxKhe+4mxgTiVEjJj/imPmCRyzksYogyt8A8gqT6PRDfXSpyz7q8myq7O6PpBqzs5+H335chuab1pWqf+bgrwMzCHiC/S7ygKBVmbcy92JBMzRJcWCLSbgJ8YLMRdj8ecE8/yy16oST8Tn6OLO2S8t8A0YvQKdFSvfxEOrogQ4oXsQ1ui3pBAMicIal4jXzBeBZ2cR0TV6p947CfwkPPNcu7DVv9IaL6z7PtDzN1rWEd025vhpVwT0K3TuKxjRaMxpbKz1ZEi5RJetnxBuZwTazA3c2Ro7D/JkqvR1sKRcoatz5+h2tkCYYIV+nasQJibRbUIgMYHs7OMPkfg+EHC73ZQv4ZrEaxxHxcZj2XsKsUvrnvGaMwkLdJXdxgrxbhED7yYbPHf7Cp5Tz4Ap7x0PpglX6F4ZBU4ndo3+sd5eZ8t0n0EgHJTn6LoHuVgiDQL9ZBEevRU8ljOLm4VDmbZClyShLCZIdIEeCwmzcfliBY0KjldCBtrcR6azRnjDAgkvVxXihdegRN9dpR6X6Ff+ecKzTEFehpRSC6+BQN/N/Ki1QVpcXqBfkIOQCLvMJjeH+8MOtaJQXbRdX/kU7S+bMz1R6P9Un7ZK/lHys35wgT5xKg2flfzhGOfzf0HXsgxOfj8ROLrMZRXuxqVeiAey1HM3gbkmtiUiiH0Tlprs4fuHHrtG/LwGPU9Y8/d6/j5hPv4HCtw+OZdXTzAAAAAASUVORK5CYII=';

  .ai-sidebar {
    transition: width 0.28s;
    width: 224px !important;
    background-color: #f7f7f7;
    height: 100%;
    font-size: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;

    &.collapse {
      width: 84px !important;

      .vh-menu {
        .vh-submenu__title {
          padding-left: 0 !important;
        }
      }
    }

    .vh-menu {
      border: none;
      height: 100%;
      width: 100%;

      .video-base .vh-submenu__title {
        .vh-iconimg {
          background-repeat: no-repeat;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALiSURBVHgB5VfBldMwEP2BC7cNHQwV4A5wB6SDuAPSwWYriLlx21DBLkdOSSpYqMC+ctqlAvDgERo7siXLylve4783T7Y01nxLo5kR8J8gb+TQyGMjv+Q5wz+CNVpSLlnjmUGNVGjJlI0sRbbS9yjvz4YCLZF7x9hBxgrMwAvMA0n7zTF26ulEYSpB6r3X0r5z6GY9naE5koDg3jL2L3Nyr1XfDtYHSekX0n+LhER5JSplcNUb32D4FG96urmaq0KCULRGN7bRgN4KdoWNbj6gS0rX9cPByJTBEumxhSU5eSUJdiu2uBy2cPuqF2YL7nB5GFuH0A8KWCcmXB46EhQhH1RTlNEeBteJ1djJvENpz0SCCh4UoYoK+kQuPTr5yDxVgM6fnDpl9QjduLdFPEGziqO+aAwRwrCH3V5uHxBPcAnPTuQeI64JK1h3GCMRQhBiu6OniwUTLE8IA2cAauQo7zfSXiMepx6XDkGStkYYDJHP8m2NtuzKEV+k1j0uHYJm0if4katJePvMVps/3yAOxvYVHASnoJC2dgjjAxKV+jEECW2VUzfyxiE3Qq5AYrDTP8AfYvYYj5WE83gWeooz4RBdgjGMv41toSGUTSR4hpeYjtdow8FxROd7I68a+YrW8X828qORT5iIhaOPV4aXOJPJjxgnMwc5bFjiELX3fUCwSVvLLdJewHmug8OOt8Qz5PhvOJaVqm+HdNjD5t1SbOnLlHMxigEFgi0oU6wiwV2U8NwmF/8N9DoO5tJ+RDeb1LA5ctbxF5iT/QXdtPokthlv4SAYgpA06IPZhauRMSd02a0V9fWTMB9LNV/W6/deN7SjsvPy6TX+l/JuXKIbIUplZ/S6QXCHmZTkXCSNHNDbpcXAx7kI+xyHnGNvfCV9oT65lPnue/0Ee/BcdqJQwMawO3nP0fVbfmb/Yr/WbhJbJ04CwZ0FfHK2fSFYIB6EduXeyzOLrspNHufCYY/IEPUbP+YaJEBVmjUAAAAASUVORK5CYII=');
        }
      }
      .video-base .vh-submenu__title:hover .vh-iconimg,
      .video-base.active .vh-submenu__title .vh-iconimg {
        background-image: url(@ai-base-active-icon-image);
      }

      .video-operate .vh-submenu__title {
        .vh-iconimg {
          background-repeat: no-repeat;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMnSURBVHgBzViLcdswDH3JAvUG5QbVCOwE9QblBtUGYidINrA6QbKBs4G7gdIJ7A0a8USYIA1+FOcufne4WCQIPnwISgE+BxvcILazHGf5P8uAG4KaZcJCjETjRjBiIbSfxfrfjuxVKVZYPOyuMGQ8maO353DwYw9YCYPFQ6oPLkc/Z9hGJTgdSqdl4x1Wplf5jTkZZ/jgRSL7hHxENSM2CfMWweEeFWLcUJ/Z1OkZTyrnuVv3wOb/Ih/lEXEgRL2JGWqprQEhkpqNa2bLzdsGWwbxSR7SydbTo7A4QIZ2CN5uGOE92mqS2x0hZIPqzFQM8CY64TKdVOTHBls5gmT/XIPEthS1gemNBV1+oHhUa/iF2HFFbHOnSSJmUYdNNjIFXRdt7tAjmOMaoUZqxAzaoZJN+4xOqUyKkXsvMY4el7cDgU5oFC2J3DEZ36Ls9Ro84jI75PhUW0yhVf5ZsTGL67FBiFKPEBAnXW1x2krI0K6y4YD4VhlQvsooQzydVVBd7BGHWyFPjDdiLgfkCfIrr6Xhnzcjry46tADuAOl1kN8+UhgsEVNYgbR5lkAk0nrRaCzyteCns1akpLd2bhXu2e9t5reEV/9XJ+NdMp+Dsz952Vd0zzVHIjVMDouQvo4Rbak5YOWHjkE4rVLDTOGcOUA+rbX3QX6YLBpayjNCn+MNc0CZoEXc5yzKxDSCEwqNByg9fdyIxsdAQU57ejtF4D2Ow7Lx6hWzgthTMkdZEw8hvb0ehLkR9duiBn6bSLfCiMxbzz1TPgmG3YJnhHczhfXEXmb5hqW9fBf2OTHdCyiUi3KDcHu4FGu0QSE+LCqjNyITOdqcNi6dtBGZTzcBGsL3QAbkuH63godF+eMl/Zjeo+ywQsPHlUW98RIM4nQZP64Rd/6+wRY15F1JqbXxEhTiNPNXrQltdfkTcUMuQqOcspRcD/kfO+4qKvXFNPU2p3iXPG/9QuWfXX96neXfLF+84Q4xcdcK/szyQxjn678iXFmE31j5jaKwpEyKCk/jzm/EC1n7tVNhLdW2RgV3lXntyToC1CxfUH9fg1+nkvUnv/7UsB5vkN6QKm5Fd4kAAAAASUVORK5CYII=');
        }
      }
      .video-operate .vh-submenu__title:hover .vh-iconimg,
      .video-operate.active .vh-submenu__title .vh-iconimg {
        background-image: url(@ai-operate-active-icon-image);
      }

      .menu-icon {
        display: inline-block;
        color: rgba(0, 0, 0, 0.85);
        width: 20px;
        height: 20px;
        font-size: 18px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: 8px;
      }

      .vh-menu-item {
        border-radius: 0;
        color: #262626;

        &.is-active {
          background: #f7f7f7;
          color: var(--theme-color);
          font-weight: normal;
        }
      }
      .vh-menu-item,
      span[slot='title'] {
        font-size: 16px;
        font-weight: normal;
      }

      .vh-submenu__icon-arrow {
        right: 34px;
        color: rgba(0, 0, 0, 0.65);
      }

      .vh-submenu__title {
        padding-left: 34px !important;
        padding-top: 12px;
        padding-bottom: 12px;
        line-height: 16px;
        font-size: 16px;
        &:hover {
          color: var(--theme-color);
          background: #f7f7f7;
        }
      }

      .vh-menu-item {
        padding-left: 61px !important;
        padding-top: 12px;
        padding-bottom: 12px;
        line-height: 16px;
        font-size: 16px;

        &:hover {
          color: var(--theme-color);
          background: #f7f7f7;
        }
      }

      .vh-menu-item.no-group {
        padding-left: 35px !important;
      }
    }
  }

  .vh-menu--vertical {
    .vh-menu--popup {
      padding: 0 0;
    }

    & > .vh-menu {
      .svg-icon {
        margin-right: 16px;
      }

      .sub-vh-icon {
        margin-right: 12px;
        margin-left: -2px;
      }
    }
    .vh-menu-item.is-active {
      color: var(--theme-color);
    }

    .vh-menu-item,
    .vh-submenu__title {
      height: 48px;
      line-height: 48px;
    }

    .vh-submenu > .vh-submenu__title,
    .vh-menu-item {
      border-left: 4px #f7f7f7 solid;

      &:hover {
        background-color: #f7f7f7 !important;
        border-left-color: #f7f7f7;
      }

      &.is-active {
        background-color: #f7f7f7 !important;
        border-left-color: var(--theme-color);
        font-weight: normal;
      }
    }
    > .vh-menu--popup {
      max-height: 100vh;
      overflow-y: auto;
      border-radius: 4px;
      min-width: 160px;
    }
  }
</style>
